<c-card *transloco="let t">


  @if(okService.billing && okService.billing.plan.hide_accounts){

    <c-card-body>
      <c-row>
        <c-col md="12">
          <h1>{{ t('Account Settings') }}</h1>

          <p>
            {{ t('Your account and billing is managed by your sales representative. ') }} {{ t('If you have any queries about your account, please email us at ') }}<a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a>.
          </p>
  
        </c-col>
      </c-row>
      </c-card-body>

  }
  @else if(okService.billing.cancelled){

    
    <c-card-body>
      
      <c-row>
        <c-col md="12">
          <h1>{{ t('Your OK Alone Account') }}</h1>
          <p *ngIf="okService.billing.trial_active">{{ t('You are currently on a Free Trial which expires on ') }}{{okService.billing.trial_end}}</p>

                <div class="alert alert-warning" role="alert" *ngIf="okService.billing.cancelled">
                  <i class="fa-solid fa-triangle-exclamation fa-lg"></i><b>{{ t('Your Account is no Longer Active') }}</b> {{ t('To talk to a team member about activating your account again, please email us at ') }}<a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a>.
                </div>


          </c-col>
        </c-row>
    </c-card-body>

  }
  @else if(okService.billing.contract_signing && okService.billing.contract_signing.uses_new_contract_system && okService.billing.plan.account_type == "Pricing2024"){


    <c-card-body>
      
      <c-row>
        <c-col md="12">
          <h1>{{ t('Your OK Alone Account') }}</h1>
          <p *ngIf="okService.billing.trial_active">{{ t('You are currently on a Free Trial which expires on ') }}{{okService.billing.trial_end}}</p>

                <div class="alert alert-warning" role="alert" *ngIf="okService.billing.trial_over">
                  <i class="fa-solid fa-triangle-exclamation fa-lg"></i><span *ngIf="okService.billing.trial_over"><b>{{ t('Your Free Trial has Expired') }}</b> {{ t('Your free trial expired on ') }}{{okService.billing.trial_end}}. {{ t('To go live please enter your credit card details below.') }} {{ t('To talk about extending your free trial or going live, please email us at ') }}<a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a>.</span>
                </div>

                <p>When you are ready to sign up please compelete the steps below to activate your account.</p>

                <app-account-signup></app-account-signup>

          </c-col>
        </c-row>
    </c-card-body>

  }
  @else{

    <c-card-body>
      
            <c-row>
              <c-col md="12">
                <h1>{{ t('Your OK Alone Account') }}</h1>
                <p *ngIf="okService.billing.trial_active">{{ t('You are currently on a Free Trial which expires on ') }}{{okService.billing.trial_end}}</p>



                <div class="alert alert-warning" role="alert" *ngIf="okService.billing.trial_over">
                  <i class="fa-solid fa-triangle-exclamation fa-lg"></i><span *ngIf="okService.billing.trial_over"><b>{{ t('Your Free Trial has Expired') }}</b> {{ t('Your free trial expired on ') }}{{okService.billing.trial_end}}. {{ t('To go live please enter your credit card details below.') }} {{ t('To talk about extending your free trial or going live, please email us at ') }}<a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a>.</span>
                </div>

                <button type="button" class="btn btn-success btn-lg text-white m-2" (click)="goToCard()">
                  <i class="fa-solid fa-credit-card"></i> {{ t('Add your Payment Details to Activate the Account') }}
                </button>

              </c-col>
            </c-row>
            @if (okService.billing.plan.account_type == "Pricing2024") {

              <div class="col-md-12" >
                <div class="card">
                  <div class="card-body">
                      <app-account-plan-2024></app-account-plan-2024>
                  </div>
                </div>
              </div>
              <div class="row">
                
              <div class="col-md-8" >
                <div id="go_to_card"></div>
                <div class="card mt-2">
                  <div class="card-header">
                    <h3>{{ t('Move to a Full Plan') }}</h3>
                  </div>
                  <div class="card-body">
                    <app-account-card></app-account-card>
                  </div>
                </div>
            </div>
            <div class="col-md-4 mt-2">
              
              <app-account-extend></app-account-extend>

              <app-account-contact></app-account-contact>

            </div>
          </div>

            }
            @else {
              
            <div class="row">
              <div class="col-md-8" >
                <div class="card">
                  <div class="card-body">
                    @if (okService.billing.plan.account_type == "Pricing2024") {
                      <app-account-plan-2024></app-account-plan-2024>
                    }
                    @else {
                      <app-account-plan></app-account-plan>
                    }
                  </div>
                </div>
                <div id="go_to_card"></div>
                  <div class="card mt-2">
                    <div class="card-header">
                      <h3>{{ t('Move to a Full Plan') }}</h3>
                    </div>
                    <div class="card-body">
                      <app-account-card></app-account-card>
                    </div>
                  </div>
              </div>
              <div class="col-md-4">
                <app-account-included></app-account-included>
                

                <app-account-extend></app-account-extend>

                <app-account-contact></app-account-contact>

              </div>
            </div>
            }
    </c-card-body>

  }

</c-card>
